import React, { useEffect, useRef, useState } from "react";

const PAD_W = 1200;
const PAD_H = 400;
const COLORS = ["#111827", "#1d4ed8", "#b91c1c"];

// กระดานวาดลายเซ็น พื้นโปร่งใส -> onDone(dataUrl PNG ที่ครอปเฉพาะลายเส้นแล้ว)
export default function DrawPad({ onDone, onEmpty }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  const [color, setColor] = useState(COLORS[0]);
  const [thickness, setThickness] = useState(5);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
  }, []);

  const point = (event) => {
    const rect = canvasRef.current.getBoundingClientRect();
    return {
      x: ((event.clientX - rect.left) / rect.width) * PAD_W,
      y: ((event.clientY - rect.top) / rect.height) * PAD_H,
    };
  };

  const stroke = (from, to) => {
    const ctx = canvasRef.current.getContext("2d");
    ctx.strokeStyle = color;
    ctx.lineWidth = thickness * 2;
    ctx.beginPath();
    ctx.moveTo(from.x, from.y);
    ctx.lineTo(to.x, to.y);
    ctx.stroke();
  };

  const onDown = (event) => {
    event.preventDefault();
    canvasRef.current.setPointerCapture(event.pointerId);
    drawing.current = true;
    last.current = point(event);
    stroke(last.current, { x: last.current.x + 0.01, y: last.current.y });
    setHasInk(true);
  };

  const onMove = (event) => {
    if (!drawing.current) return;
    const p = point(event);
    stroke(last.current, p);
    last.current = p;
  };

  const onUp = () => {
    drawing.current = false;
  };

  const clear = () => {
    canvasRef.current.getContext("2d").clearRect(0, 0, PAD_W, PAD_H);
    setHasInk(false);
  };

  const finish = () => {
    const canvas = canvasRef.current;
    const { data } = canvas.getContext("2d").getImageData(0, 0, PAD_W, PAD_H);
    let minX = PAD_W, minY = PAD_H, maxX = -1, maxY = -1;
    for (let y = 0; y < PAD_H; y += 1) {
      for (let x = 0; x < PAD_W; x += 1) {
        if (data[(y * PAD_W + x) * 4 + 3] > 0) {
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }
    }
    if (maxX < 0) {
      onEmpty?.();
      return;
    }
    const pad = 8;
    minX = Math.max(0, minX - pad);
    minY = Math.max(0, minY - pad);
    maxX = Math.min(PAD_W - 1, maxX + pad);
    maxY = Math.min(PAD_H - 1, maxY + pad);
    const out = document.createElement("canvas");
    out.width = maxX - minX + 1;
    out.height = maxY - minY + 1;
    out.getContext("2d").drawImage(canvas, minX, minY, out.width, out.height, 0, 0, out.width, out.height);
    onDone(out.toDataURL("image/png"));
  };

  return (
    <div>
      <div
        style={{
          borderRadius: 12,
          border: "1px dashed rgba(12,118,229,0.4)",
          backgroundColor: "#fff",
          backgroundImage:
            "linear-gradient(45deg,#f1f5f9 25%,transparent 25%,transparent 75%,#f1f5f9 75%),linear-gradient(45deg,#f1f5f9 25%,transparent 25%,transparent 75%,#f1f5f9 75%)",
          backgroundSize: "20px 20px",
          backgroundPosition: "0 0,10px 10px",
          overflow: "hidden",
        }}
      >
        <canvas
          ref={canvasRef}
          width={PAD_W}
          height={PAD_H}
          style={{ width: "100%", height: "auto", aspectRatio: `${PAD_W} / ${PAD_H}`, touchAction: "none", cursor: "crosshair", display: "block" }}
          onPointerDown={onDown}
          onPointerMove={onMove}
          onPointerUp={onUp}
          onPointerCancel={onUp}
        />
      </div>
      <div className="d-flex align-items-center flex-wrap gap-3 mt-2">
        <div className="d-flex align-items-center gap-2">
          {COLORS.map((c) => (
            <button
              key={c}
              type="button"
              aria-label={`สี ${c}`}
              onClick={() => setColor(c)}
              style={{ width: 26, height: 26, borderRadius: "50%", background: c, border: color === c ? "3px solid #0c76e5" : "2px solid #fff", boxShadow: "0 0 0 1px #cbd5e1" }}
            />
          ))}
        </div>
        <div className="d-flex align-items-center gap-2 small text-secondary">
          ความหนา
          <input type="range" min="2" max="12" value={thickness} onChange={(e) => setThickness(Number(e.target.value))} />
        </div>
        <div className="ms-auto d-flex gap-2">
          <button type="button" className="btn btn-outline-secondary btn-sm" onClick={clear} disabled={!hasInk}>
            <i className="fa-solid fa-eraser me-1" />ล้าง
          </button>
          <button type="button" className="btn btn-primary btn-sm" onClick={finish} disabled={!hasInk}>
            <i className="fa-solid fa-check me-1" />ใช้ลายเซ็นนี้
          </button>
        </div>
      </div>
    </div>
  );
}
